'use client';

import { useState } from 'react';
import { SeoExam, SeoSpecialty } from '@medprev-web-app/api-graphql-client';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { CtaProcedureTelemedicineButton } from '@/app/(main)/(pages)/(institucional)/(index)/_components/cta/buttons/cta-procedure-telemedicine.component';
import { FormNotifyMe } from '@/app/(main)/(pages)/_components/face-to-face-service-section/form-notify-me.component';
import { Sheet, SheetContent } from '@/components/ui/sheet';
import { Typography } from '@/components/ui/typography/typography.component';
import { TypographyVariant } from '@/components/ui/typography/typography.type';
import { Place } from '@/types/google-maps.types';

export default function CtaModalNotifyMe({
  open,
  onOpenChange,
  place,
  procedure,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  procedure?: SeoSpecialty | SeoExam | null;
  place: Pick<Place, 'state' | 'city'>;
}) {
  const [isFormCompleted, setIsFormCompleted] = useState(false);
  const telehealthUrl = procedure && 'telehealthUrl' in procedure
    ? (procedure as SeoSpecialty).telehealthUrl
    : null;

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="centerFit" closingTagPosition="right" className="sm:max-h-fit">
        <div data-testid={DataTestIdEnum.SEO_CTA_SCHEDULE_NO_BRANCH_MODAL} className="flex flex-col gap-4 h-full">
          {isFormCompleted
            ? (
                <div className="flex flex-col gap-6">
                  <Typography variant={TypographyVariant.MODAL_TITLE}>Obrigado!</Typography>
                  <Typography>
                    Você será avisado quando tivermos consultas disponíveis em
                    {' '}
                    {place?.city}
                    {' '}
                    -
                    {' '}
                    {place?.state}
                  </Typography>
                </div>
              )
            : (
                <>
                  <FormNotifyMe
                    disableCardStyle={true}
                    title="Atendimento presencial"
                    onSubmitCallback={() => {
                      setIsFormCompleted(true);
                    }}
                    description="Seja notificado quando uma especialidade chegar à sua cidade."
                  />
                </>
              )}

          <CtaProcedureTelemedicineButton
            title="Ou agende uma teleconsulta"
            combinedWithOthers
            telehealthUrl={telehealthUrl}
            withStartIcon={false}
            place={place}
            procedure={procedure}
            originCta="notify-me-modal"
          />
        </div>
      </SheetContent>
    </Sheet>
  );
}
